import { Box, Stack, Typography } from '@mui/material'
import { WeightClassResponseDto } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

type Props = {
  weightClassDto?: WeightClassResponseDto | null
}

export const OrderWeightClass: FC<Props> = observer(({ weightClassDto }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const weightLabel = weightClassDto?.maxWeight
    ? `${weightClassDto.minWeight}-${weightClassDto.maxWeight}`
    : `${weightClassDto?.minWeight}+`

  const containerSizeLabel = weightClassDto?.weightClassSetContainerLength
    ? `${weightClassDto?.weightClassSetContainerLength}ft`
    : t('sharedByAllContainerSizes', 'shared by all container sizes')

  return (
    <Box
      padding={theme.customSpacing.s}
      borderRadius={theme.customRadius.medium}
      sx={{
        bgcolor: theme.palette.background.neutral,
      }}
    >
      <Stack>
        <Typography variant='body2' color='secondary'>
          {t('weightClass', 'Weight class')}
        </Typography>
        {weightClassDto?.id ? (
          <>
            <Typography variant='subtitle2'>
              {weightClassDto?.name} {`(${weightLabel} kg, ${containerSizeLabel})`}
            </Typography>
            <Typography variant='caption'>{weightClassDto?.weightClassSetName}</Typography>
          </>
        ) : (
          <Typography variant='subtitle2'>{t('noInformation', 'No information')}</Typography>
        )}
      </Stack>
    </Box>
  )
})
